// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-card {
  display: flex;
  align-items: center;
  padding: var(--space-4);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-subtle);
  background-color: var(--color-white);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.search-card:hover {
  border-color: var(--color-primary-green);
  box-shadow: var(--shadow-sm);
}

.search-card.selected {
  border-color: var(--color-primary-green);
  background-color: var(--color-light-green);
}

.search-card-image-container {
  width: 88px;
  height: 88px;
  margin-right: 16px;
  flex-shrink: 0;
}

.search-card-image {
  width: 88px !important;
  height: 88px !important;
  object-fit: cover;
  border-radius: 6px;
}

.search-card-image-placeholder {
  width: 100%;
  height: 100%;
  background-color: var(--color-light-gray);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gray);
}

.search-card-info {
  flex: 1;
  min-width: 0;
}

.search-card-company {
  color: var(--color-dark-gray);
  margin-bottom: 4px;
}

.search-card-name {
  color: var(--color-black);
  margin-bottom: 8px;
  line-height: 1.2;
}

.search-card-category {
  margin-top: 4px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .search-card {
    padding: 12px;
  }
  
  .search-card-image-container {
    width: 64px;
    height: 64px;
    margin-right: 12px;
  }
  
  .search-card-image {
    width: 64px !important;
    height: 64px !important;
  }
}

@media (max-width: 480px) {
  .search-card {
    padding: 10px;
  }
  
  .search-card-image-container {
    width: 64px;
    height: 64px;
    margin-right: 10px;
  }
  
  .search-card-image {
    width: 64px !important;
    height: 64px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchCard/SearchCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".search-card {\n  display: flex;\n  align-items: center;\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border-subtle);\n  background-color: var(--color-white);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.search-card:hover {\n  border-color: var(--color-primary-green);\n  box-shadow: var(--shadow-sm);\n}\n\n.search-card.selected {\n  border-color: var(--color-primary-green);\n  background-color: var(--color-light-green);\n}\n\n.search-card-image-container {\n  width: 88px;\n  height: 88px;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n\n.search-card-image {\n  width: 88px !important;\n  height: 88px !important;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.search-card-image-placeholder {\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-light-gray);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-gray);\n}\n\n.search-card-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.search-card-company {\n  color: var(--color-dark-gray);\n  margin-bottom: 4px;\n}\n\n.search-card-name {\n  color: var(--color-black);\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.search-card-category {\n  margin-top: 4px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .search-card {\n    padding: 12px;\n  }\n  \n  .search-card-image-container {\n    width: 64px;\n    height: 64px;\n    margin-right: 12px;\n  }\n  \n  .search-card-image {\n    width: 64px !important;\n    height: 64px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .search-card {\n    padding: 10px;\n  }\n  \n  .search-card-image-container {\n    width: 64px;\n    height: 64px;\n    margin-right: 10px;\n  }\n  \n  .search-card-image {\n    width: 64px !important;\n    height: 64px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
